import React from "react";

const ButtonsGroup = ({ element }) => {
  return (
    <div className="form_field_buttonGroup-outer">
      {element.data.values.length > 0 &&
        element.data.values.map((val, index) => (
          <button key={`${val.label}-${val.value}-${index}`} className="form_field_button_group">
            {val.label}
          </button>
        ))}
    </div>
  );
};

export default ButtonsGroup;
